import { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { RecoilRoot } from 'recoil';
import RecoilNexus from "recoil-nexus";
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './Apps/AuthProvider';
import { Loader } from './core';
import './style.scss';
const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <RecoilRoot>
        <RecoilNexus/> {/* Helps to update  atoms  values outside from react Component*/}
        <Suspense fallback ={<Loader size ={40} type= 'full' text ={'Loading'} />}>
            <AuthProvider />
        </Suspense>
    </RecoilRoot>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
